<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">Neveryóna</h1>
<h2 class="center">Or: The Tale of Signs and Cities</h2>
<h3 class="center" style="margin-top:80px;">Samuel R. Delany</h3>
<p class="center" style="margin-top:80px;"><img alt="logo" src="logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3title_page.vue?79af31f8